import { useTheme } from '@mui/material';
import React from 'react';

const Logo: React.FC<{
  style?: any;
  textColor?: string;
  showText?: boolean;
  height?: number;
  width?: number;
  color?: string;
}> = ({
  style,
  width = 34,
  height,
  showText = true,
  textColor: textColorProp,
  color,
}) => {
  const theme = useTheme();

  const textColor =
    textColorProp || theme.palette.mode === 'dark' ? '#fff' : '#001339';

  return (
    <svg
      width={showText ? width + 98 : width}
      height={height || width}
      style={{ ...style, minWidth: showText ? width + 98 : width, width }}
      viewBox={showText ? '0 0 132 34' : '0 0 34 34'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2231 0H20.6064L11.0081 20.0693H23.3584L19.801 26.7143H0.000171661L13.2231 0Z"
        fill={color || '#003F91'}
      />
      <path
        d="M13.2231 0H20.6064L11.0081 20.0693H23.3584L19.801 26.7143H0.000171661L13.2231 0Z"
        fill="url(#paint0_linear_1227_2)"
        fillOpacity="0.2"
      />
      <path
        d="M13.2231 0H20.6064L11.0081 20.0693H23.3584L19.801 26.7143H0.000171661L13.2231 0Z"
        fill="url(#paint1_linear_1227_2)"
        fillOpacity="0.2"
      />
      <path
        d="M21.0763 15.3037L24.5666 8.12168L34.2321 26.7143H26.7816L21.0763 15.3037Z"
        fill={color || '#003F91'}
      />
      <path
        d="M21.0763 15.3037L24.5666 8.12168L34.2321 26.7143H26.7816L21.0763 15.3037Z"
        fill="url(#paint2_linear_1227_2)"
        fillOpacity="0.2"
      />
      <path
        d="M21.0763 15.3037L24.5666 8.12168L34.2321 26.7143H26.7816L21.0763 15.3037Z"
        fill="url(#paint3_linear_1227_2)"
        fillOpacity="0.2"
      />
      {showText && (
        <>
          <path
            d="M40.1715 7.28967H50.7408C51.6868 7.28967 52.5023 7.48406 53.1548 7.90523C53.8072 8.32641 54.3617 8.84477 54.7532 9.49273C55.1773 10.1407 55.4709 10.8534 55.6666 11.6634C55.8623 12.4733 55.9602 13.2509 55.9602 14.0284V26.3073C55.9602 26.5665 55.8297 26.6637 55.6013 26.6637H42.5203C41.77 26.6637 41.1502 26.4369 40.6935 25.9833C40.2042 25.5297 39.8453 24.979 39.5844 24.3634C39.3234 23.7478 39.1277 23.1323 39.0298 22.5167C38.9319 21.9012 38.8667 21.4152 38.8667 21.0912C38.8667 20.508 38.9319 19.8277 39.0951 19.1149C39.2582 18.4022 39.4865 17.7218 39.8127 17.1387C40.1389 16.5231 40.563 16.0047 41.0849 15.5835C41.6069 15.1624 42.2593 14.9356 43.0096 14.9356H49.2728C49.9253 14.9356 50.4472 14.7736 50.8387 14.482C51.2301 14.158 51.4258 13.8017 51.4258 13.3805C51.4258 13.0241 51.2954 12.7001 51.067 12.3437C50.806 11.9874 50.4798 11.8254 50.0884 11.8254H40.2368C39.9758 11.8254 39.878 11.6958 39.878 11.469V7.67844C39.7801 7.41926 39.9106 7.28967 40.1715 7.28967ZM51.0018 22.3223C51.2627 22.3223 51.3606 22.1927 51.3606 21.9659V19.6981C51.3606 19.4389 51.2301 19.3417 51.0018 19.3417H44.347C43.9882 19.3417 43.6946 19.4713 43.4989 19.7629C43.2706 20.0545 43.1727 20.3784 43.1727 20.7024C43.1727 21.1236 43.3032 21.5124 43.5315 21.804C43.7925 22.1279 44.1187 22.2899 44.5754 22.2899H51.0018V22.3223Z"
            fill={textColor}
          />
          <path
            d="M68.845 7.29033C69.106 7.29033 69.2038 7.41992 69.2038 7.6467V11.4373C69.2038 11.6965 69.0733 11.7937 68.845 11.7937H65.2567C65.0283 11.7937 64.8326 11.8584 64.6695 11.988C64.5064 12.1176 64.3433 12.2472 64.2128 12.4092C64.0823 12.5712 63.9844 12.7332 63.8866 12.9276C63.8213 13.122 63.7887 13.284 63.7887 13.4136V26.2432C63.7887 26.5023 63.6582 26.5995 63.4299 26.5995H59.2217C58.9608 26.5995 58.8629 26.4699 58.8629 26.2432V12.1176C58.8629 11.4697 58.9934 10.8541 59.2544 10.2709C59.5153 9.68778 59.8742 9.16942 60.3309 8.71584C60.7876 8.26227 61.3095 7.90589 61.8967 7.6467C62.4839 7.38752 63.1363 7.25793 63.8213 7.25793H68.845V7.29033Z"
            fill={textColor}
          />
          <path
            d="M71.2604 9.52579C71.2604 8.91023 71.4887 8.39187 71.978 7.93829C72.4674 7.51712 72.9893 7.29033 73.5439 7.29033H81.3077C81.9601 7.29033 82.5473 7.45232 83.1018 7.7439C83.6564 8.03549 84.0479 8.32707 84.3088 8.55385C84.4393 8.68345 84.5698 8.81303 84.7329 8.97502C84.896 9.13701 84.9939 9.20181 85.0591 9.20181C85.1244 9.20181 85.1896 9.16942 85.2549 9.07222C85.3527 8.97503 85.4506 8.87783 85.5811 8.71584C85.7116 8.55385 85.8746 8.39186 86.0378 8.22987C86.2335 8.06788 86.4618 7.9059 86.7228 7.7763C87.2121 7.51712 87.7341 7.35512 88.256 7.32272C88.7779 7.29033 89.1042 7.25793 89.2346 7.25793H91.9096C92.9208 7.25793 93.8668 7.45232 94.715 7.84109C95.5631 8.22987 96.2808 8.71584 96.9006 9.299C97.5204 9.88217 97.9771 10.5625 98.3359 11.2753C98.6621 12.0204 98.8252 12.7332 98.8252 13.4136V26.2432C98.8252 26.5023 98.6948 26.5995 98.4664 26.5995H94.6824C94.4214 26.5995 94.2583 26.4699 94.2583 26.2432V13.8995C94.2583 13.5107 94.1604 13.1544 93.9973 12.8304C93.8342 12.5064 93.6059 12.2472 93.3449 12.0204C93.0839 11.7936 92.7903 11.6317 92.4968 11.5345C92.1705 11.4373 91.8769 11.3725 91.616 11.3725H89.1368C88.6801 11.3725 88.256 11.5345 87.7993 11.8584C87.3752 12.1824 87.1469 12.6684 87.1469 13.3164V26.2107C87.1469 26.4699 87.0164 26.5671 86.7881 26.5671H82.9714C82.7104 26.5671 82.6125 26.4375 82.6125 26.2107V13.3164C82.6125 12.8304 82.3842 12.3768 81.8949 11.9556C81.4056 11.5345 80.8836 11.3401 80.2964 11.3401H76.8386C76.5776 11.3401 76.3493 11.4373 76.1535 11.6641C75.9578 11.8908 75.86 12.15 75.86 12.4416V26.2107C75.86 26.4699 75.7295 26.5671 75.5011 26.5671H71.6844C71.4235 26.5671 71.3256 26.4375 71.3256 26.2107V9.52579H71.2604Z"
            fill={textColor}
          />
          <path
            d="M113.145 12.538C112.297 12.052 111.22 11.8253 109.981 11.8253C109.557 11.8253 109.133 11.8577 108.708 11.89C108.284 11.9224 107.893 11.9872 107.567 12.1168C107.241 12.214 106.947 12.4084 106.719 12.6028C106.49 12.8296 106.392 13.1212 106.392 13.4452V26.2747C106.392 26.5339 106.262 26.6311 106.034 26.6311H102.217C101.956 26.6311 101.858 26.5015 101.858 26.2747V22.4842V22.4194V0.35637C101.858 0.097186 101.989 0 102.217 0H106.034C106.295 0 106.392 0.129584 106.392 0.35637V7.28954H112.917C113.7 7.28954 114.45 7.41913 115.167 7.71071C115.918 8.00229 116.538 8.39107 117.125 8.90944C117.679 9.42781 118.136 10.011 118.495 10.6913C118.854 11.3717 119.017 12.052 119.017 12.7972V26.3072C119.017 26.5663 118.886 26.6635 118.658 26.6635H114.841C114.58 26.6635 114.482 26.5339 114.482 26.3072V14.9355C114.45 13.8339 113.993 13.024 113.145 12.538Z"
            fill={textColor}
          />
          <path
            d="M131.641 7.29033C131.902 7.29033 132 7.41992 132 7.6467V11.4373C132 11.6965 131.87 11.7937 131.641 11.7937H128.053C127.825 11.7937 127.629 11.8584 127.466 11.988C127.303 12.1176 127.14 12.2472 127.009 12.4092C126.879 12.5712 126.781 12.7332 126.683 12.9276C126.618 13.122 126.585 13.284 126.585 13.4136V26.2432C126.585 26.5023 126.455 26.5995 126.226 26.5995H122.018C121.757 26.5995 121.659 26.4699 121.659 26.2432V12.1176C121.659 11.4697 121.79 10.8541 122.051 10.2709C122.312 9.68778 122.671 9.16942 123.127 8.71584C123.584 8.26227 124.106 7.90589 124.693 7.6467C125.28 7.38752 125.933 7.25793 126.618 7.25793H131.641V7.29033Z"
            fill={textColor}
          />
        </>
      )}
      <defs>
        <linearGradient
          id="paint0_linear_1227_2"
          x1="17.1161"
          y1="0"
          x2="17.1161"
          y2="26.7143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#121111" />
          <stop offset="0.78125" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1227_2"
          x1="17.1161"
          y1="3.98889e-07"
          x2="11.8106"
          y2="21.6795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF2FF" />
          <stop offset="1" stopColor="#121111" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1227_2"
          x1="17.1161"
          y1="0"
          x2="17.1161"
          y2="26.7143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#121111" />
          <stop offset="0.78125" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1227_2"
          x1="17.1161"
          y1="3.98889e-07"
          x2="11.8106"
          y2="21.6795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF2FF" />
          <stop offset="1" stopColor="#121111" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
